module.exports = __webpack_public_path__ + "img/chest.dba8b72f.png";